var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"inline-flex align-items-center gap-x-xxs rounded-xxs font-small",class:{'opacity-50': _vm.tag.archived},style:({
    color: _vm.tag.text_color,
    'background-color': _vm.tag.color,
    'padding': '2px 4px'
  })},[_vm._v("\n  "+_vm._s(_vm.tag.abbreviation)+" "+_vm._s(_vm.tagCount)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }